// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
// import * as Turbo from "@hotwired/turbo";
import "@hotwired/turbo-rails"

// Pull actioncable into the INITIAL bundle so turbo-rails never has to fetch it mid-page (#59).
//
// `app/views/shared/_notifications.html.erb` renders `turbo_stream_from current_user`, so a
// `<turbo-cable-stream-source>` is on every page of every signed-in user. Its `connectedCallback`
// awaits turbo-rails' `turbo/cable.js`, which does
// `await import(/* webpackChunkName: "actioncable" */ "@rails/actioncable/src")` — a lazy *network
// fetch*, on every signed-in page load. When that fetch loses a race, the page throws
// `ChunkLoadError: Loading chunk NNN failed` and the cable stream never connects, so live
// notifications silently stop working for that page load. In CI it also fails whichever browser test
// happened to be running (apparition has `js_errors: true`, which is worth keeping) — that was ~1 CI
// run in 3.
//
// Why it was lazy at all was OUR bug, not turbo's: `app/javascript/channels/index.js`
// `require.context`s only `*_channel.js` files and there are none, so `channels/consumer.js` — the
// one eager actioncable import in the app — is never imported by anything. Nothing put actioncable
// in an initial chunk, so turbo's dynamic import was its only consumer.
//
// THE SPECIFIER HERE IS LOAD-BEARING: it must be `@rails/actioncable/src`, byte-for-byte what turbo
// imports. The package's `main` is `app/assets/javascripts/action_cable.js` (a prebuilt UMD file), so
// `@rails/actioncable` and `@rails/actioncable/src` are *different modules* to webpack — importing
// the short form would ship a second copy of actioncable and dedupe nothing. (Which is also why
// `consumer.js` is left alone rather than "fixed": it imports the short form, and it calls
// `createConsumer()`, which would open a websocket on every page.)
//
// Side-effect-free: `src/index.js` is re-exports and function declarations only. Importing it moves
// code from a lazy chunk into the initial one; it does not open a connection.
import "@rails/actioncable/src"
import * as ActiveStorage from "@rails/activestorage"
import "@primer/octicons/build/build.css"
import Alpine from "alpinejs"
import "channels"
import "stylesheets/application.scss"
import "controllers"

window.Rails = Rails;
Rails.start()
ActiveStorage.start()
window.Alpine = Alpine;

// Start Alpine when the DOM is ready, NOT on window.load.
//
// window.load waits for every subresource on the page, including turbo-rails' lazily-imported
// actioncable chunk that every signed-in page pulls in via turbo_stream_from. Until Alpine starts,
// every `@click` in the app is dead and every `x-text` still shows its server-rendered fallback —
// so the UI looks interactive and silently isn't. Concretely: the "(Show N Ancestors)" toggle in
// _view_topic_main.html.erb renders the literal word "Show" and does nothing when clicked. That
// window is short on a fast connection and unbounded on a slow one; there is no reason to hold
// interactivity hostage to an image or a lazy chunk. Alpine is designed to be started at DOM-ready
// and picks up later markup via its MutationObserver.
//
// The `data-js-ready` marker on <html> is the readiness signal a caller can wait on. Alpine 3
// dispatches `alpine:initialized` on document once start() has walked the DOM, so this is exactly
// "interactivity is live", not merely "the script downloaded". The browser tests wait on it instead
// of racing the page (#49 — three separate tests were failing on this, all reading as unrelated
// assertion bugs).
document.addEventListener('alpine:initialized', () => {
  document.documentElement.setAttribute('data-js-ready', '');
});

// #133: strip Alpine-GENERATED `x-for` children before Turbo caches the page.
//
// Turbo snapshots the live DOM on `turbo:before-cache`, which is *after* Alpine has expanded every
// `<template x-for="id in selected">` into real sibling elements. Those elements carry expressions
// that only mean anything inside the loop's scope — `:class="meta(id).skip ? …"`,
// `x-show="meta(id).skip"`. The `<template>` is inert markup, but its output is not.
//
// So when Turbo re-inserts that snapshot — as the stale PREVIEW it paints before a fresh response,
// or on a back navigation — Alpine walks those orphans as ordinary markup with no loop scope, `id`
// resolves to nothing, and it throws `ReferenceError: id is not defined` from an effect. That is
// exactly the shape of the error: an identifier that exists nowhere in the source outside a
// template, reported after a navigation rather than on first render. The bulk-ban flow makes the
// preview certain, because the POST redirects back to the same URL it was cached from.
//
// Alpine tracks what it generated in `template._x_lookup` (3.7.0), so this removes precisely those
// nodes and nothing an author wrote. Alpine regenerates them from the template on the next render,
// so there is nothing to restore.
//
// Related-but-different: the pack's own note below records `ReferenceError: categoryTags is not
// defined` from starting Alpine before its globals existed. Same error shape, different cause —
// both are "an expression evaluated where its identifier is not in scope", which is worth
// recognising as a family.
document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('template[x-for]').forEach((tpl) => {
    const lookup = tpl._x_lookup;
    if (!lookup) return;
    Object.values(lookup).forEach((el) => {
      if (el && typeof el.remove === 'function') el.remove();
    });
  });
});
// NB: Alpine.start() is called at the BOTTOM of this file, not here. See the comment there.
require("jquery")

import './adm';
import './tabs';
import { cgTreeFilters } from '../cartograph/cgTreeFilters';
window.cgTreeFilters = cgTreeFilters;
import { initPageTransitions } from '../scarce_mono/pageTransitions';
import { initDreambg } from '../scarce_mono/dreambg';
import { initFontSize } from '../scarce_mono/fontSize';
import { initNotificationsMenu } from '../scarce_mono/notificationsMenu';
initPageTransitions();
initDreambg();
initFontSize();
initNotificationsMenu();
document.addEventListener('turbo:load', () => initDreambg());
require('./nested-forms/addFields');
require('./nested-forms/removeFields');
require('./ctrlEnter');
require('./markdown');
require('./categoryTags');

// Alpine starts LAST, and the position is load-bearing.
//
// Alpine's `x-data` expressions reference globals defined by the requires above — `categoryTags`
// (window.categoryTags in packs/categoryTags.js) among them. `require` calls run where they sit, so
// starting Alpine higher up in this file starts it before those globals exist: the first `x-data`
// Alpine evaluates throws `ReferenceError: categoryTags is not defined`. That is not hypothetical —
// it is what happened when this call was placed next to `window.Alpine = Alpine` above, and
// apparition surfaced it immediately because js_errors is on.
//
// The old `window.addEventListener('load', ...)` hid the ordering question by starting Alpine so
// late that nothing could be undefined. Starting at DOM-ready is the right behaviour (see the long
// comment above) but it means the ordering has to be respected explicitly.
//
// `readyState === 'loading'` still has to be handled: this pack is not guaranteed to execute before
// DOMContentLoaded, and if the event has already fired the listener would never run at all.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => Alpine.start());
} else {
  Alpine.start();
}
